import { BaseService } from '@services/BaseService';
import { OptionsViewModel, PageViewModel } from '@models/common.models';
import { CustomerViewModel } from '@models/Customer';

class CustomerService extends BaseService {
  constructor() {
    super('customer');
  }

  resetPassword = (accountId: number) => {
    return this.fetch(`resetWebPassword/${accountId}`, {
      method: 'POST'
    });
  };

  saveCustomer(model: CustomerViewModel) {
    return this.fetch<number>('', {
      method: 'POST',
      body: JSON.stringify(model)
    });
  }

  getCustomer(id: number) {
    var timeNow = Date.now().toString();
    return this.fetch<CustomerViewModel>(`${id}?time=${timeNow}`, {
      method: 'GET'
    });
  }

  getCustomerByAccountId(accountId: number) {
    return this.fetch<CustomerViewModel>(`?accountId=${accountId}`, {
      method: 'GET'
    });
  }

  getCustomerTypes() {
    return this.fetch<OptionsViewModel[]>('types', {
      method: 'GET'
    });
  }

  getCustomerStatuses() {
    return this.fetch<OptionsViewModel[]>('statuses', {
      method: 'GET'
    });
  }

  getLanguages() {
    return this.fetch<OptionsViewModel[]>('Languages', {
      method: 'GET'
    });
  }

  searchCustomers = (
    query: string | null,
    id?: number,
    pageNumber?: number,
    pageSize?: number,
    orderBy?: string,
    orderDirection?: string
  ) => {
    const pn: number | undefined = pageNumber ? Math.max(0, pageNumber) : undefined;
    const ps: number | undefined = pageSize ? Math.max(0, pageSize) : undefined;

    return this.fetch<PageViewModel<CustomerViewModel>>('Search', {
      method: 'POST',
      body: JSON.stringify({
        id: id,
        query: query,
        pageNumber: pn,
        pageSize: ps,
        orderBy: orderBy,
        orderDirection: orderDirection
      })
    });
  };
}

export const customerService = new CustomerService();



// WEBPACK FOOTER //
// ./src/_services/CustomerService.ts